import { IZones } from '../../interfaces';

export const zones: IZones[] = [
    {
        id: 857185,
        nombre: 'Zona 1',
        codigo: 'Zona 1',
        color: '#ff5e00',
        dia: 'LU-MI-MA',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: ['5903', '5904', '5908'],
    },
    {
        id: 857186,
        nombre: 'Zona 2',
        codigo: ' 2',
        color: '#02ad0b',
        dia: 'MA-MI-LU',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: ['5903', '5904'],
    },
    {
        id: 857187,
        nombre: 'Zona 3',
        codigo: 'Zona 3',
        color: '#10b7f9',
        dia: 'LU-MA-MI',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: ['5908'],
    },
    {
        id: 857189,
        nombre: 'Zona 4',
        codigo: ' 4',
        color: '#3bdf26',
        dia: 'LU-MA-MI-JU-VI-SA-DO',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: ['5903', '5904'],
    },
    {
        id: 889494,
        nombre: 'Zona A',
        codigo: 'Zona A',
        color: '#0051ff',
        dia: 'LU-MA-MI-JU-VI',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889496,
        nombre: 'Zona B',
        codigo: 'Zona B',
        color: '#00ff91',
        dia: 'LU-MA-VI',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889498,
        nombre: 'Zona C',
        codigo: 'Zona C',
        color: '#ff9100',
        dia: 'JU-VI',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889500,
        nombre: 'Zona D',
        codigo: 'Zona D',
        color: '#ae00ff',
        dia: 'JU',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889502,
        nombre: 'Zona E',
        codigo: 'Zona E',
        color: '#ff008c',
        dia: 'MA-MI',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889703,
        nombre: 'Prueba jueves',
        codigo: 'PJU',
        color: '#ff0000',
        dia: 'JU',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889980,
        nombre: 'La Plata Centro',
        codigo: '108 uni',
        color: '#ff0000',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889982,
        nombre: 'Ensenada/Dique 1',
        codigo: '109 uni',
        color: '#4800ff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889984,
        nombre: 'La Plata Oeste',
        codigo: '111 uni',
        color: '#ff00ea',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889986,
        nombre: 'La Plata Sur',
        codigo: '112 uni',
        color: '#ff9100',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889988,
        nombre: 'La Plata Este',
        codigo: '113 uni',
        color: '#0059ff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889990,
        nombre: 'Veronica ',
        codigo: '192 uni',
        color: '#0059ff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889992,
        nombre: 'La Plata Sur',
        codigo: '194 uni',
        color: '#00eaff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889994,
        nombre: 'Berisso',
        codigo: '195 uni',
        color: '#ee00ff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889996,
        nombre: 'La Plata Oeste ',
        codigo: '196 uni',
        color: '#f2ff00',
        dia: '',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 889998,
        nombre: 'Global Ensenada Berisso',
        codigo: '197 uni',
        color: '#00ff15',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890000,
        nombre: 'Global Abasto',
        codigo: '198 uni',
        color: '#cc00ff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890002,
        nombre: 'Global Central',
        codigo: '199 uni',
        color: '#77ff00',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890006,
        nombre: 'Centro',
        codigo: '201 ujni',
        color: '#0051ff',
        dia: 'LU-MA-MI-JU-VI-SA',
        codigo_tipo_zona: 'TRABAJO',
        tipo_zona_descripcion: 'Trabajo',
        tipo_zona_id: '23',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890008,
        nombre: 'Punto 3',
        codigo: 'Punto 3',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890010,
        nombre: 'Ciudad Evita - Villa',
        codigo: 'Ciudad Evita - Villa',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890012,
        nombre: 'Lomaz de Zamora',
        codigo: 'Lomaz de Zamora',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890014,
        nombre: 'Lanus - Avellaneda',
        codigo: 'Lanus - Avellaneda',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890016,
        nombre: 'Avellaneda',
        codigo: 'Avellaneda',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890018,
        nombre: 'QUILMES',
        codigo: 'QUILMES',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890020,
        nombre: 'Lanus',
        codigo: 'Lanus',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890022,
        nombre: 'Maximo Paz - T. Suarez',
        codigo: 'Maximo Paz - T. Suarez',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890024,
        nombre: 'Cannig',
        codigo: 'Cannig',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890026,
        nombre: 'Monte grande - Tapiales',
        codigo: 'Monte grande - Tapiales',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890028,
        nombre: 'Almte. Brown',
        codigo: 'Almte. Brown',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890030,
        nombre: 'Longchamps - Glew',
        codigo: 'Longchamps - Glew',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890032,
        nombre: 'A. Korn - San Vicente',
        codigo: 'A. Korn - San Vicente',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890034,
        nombre: 'F. Varela',
        codigo: 'F. Varela',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890036,
        nombre: 'Berazategui',
        codigo: 'Berazategui',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 890038,
        nombre: 'El Pato',
        codigo: 'El Pato',
        color: '',
        dia: '',
        codigo_tipo_zona: 'VENTAS',
        tipo_zona_descripcion: 'Ventas',
        tipo_zona_id: '2',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 915185,
        nombre: 'MX Puebla',
        codigo: 'MX 6',
        color: '#ff0000',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: ['117115', '116065', '15805', '116064', '5908'],
    },
    {
        id: 915186,
        nombre: 'MX Norte',
        codigo: 'MX 1',
        color: '#c400ff',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 915187,
        nombre: 'MX Centro',
        codigo: 'MX 2',
        color: '#001eff',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 915188,
        nombre: 'MX Sur',
        codigo: 'MX 3',
        color: '#59ff00',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 915189,
        nombre: 'MX CDMX',
        codigo: 'MX 4',
        color: '#00ffbb',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 915849,
        nombre: 'Zona Flores',
        codigo: 'Zon Flores',
        color: '#00ffae',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: ['5904'],
    },
    {
        id: 939322,
        nombre: 'bahia',
        codigo: 'bahia1',
        color: '#ff0000',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
    {
        id: 943243,
        nombre: 'Buenos Aires Prov',
        codigo: 'Buenos Aires Prov',
        color: '#006fff',
        dia: '',
        codigo_tipo_zona: 'ENTREGA',
        tipo_zona_descripcion: 'Entrega',
        tipo_zona_id: '1',
        detalle: [],
        dispositivos: [],
    },
];
